export const TPKColors = {
    childAccent: '#EE3124',
    parentAccent: '#0054A6',
    childLight: '#FCB851',
    parentLight: '#00C2F3',
    tiltedTextBorderA: '#D63934',
    tiltedTextBackgroundA: '#F2BA44',
    tiltedTextBorderB: '#004B98',
    tiltedTextBackgroundB: '#3EBFE8',
    homeSubtitle: '#004C97',
    carouselBlue: '#41B8E9',
    faqBorder: '#FFF9EF',
    homeCover: '#41B8E9',
    mobileHomeCover: '#5fbce3',
    borderCard: '#FBBB08',
    explanationBlue: '#00C2F3',
    disableText: '#999999',
    disableBackground: '#F0F0F0',
    exclamationCirleColor: '#87604F',
    exclamationColor: '#FFAA00',
    circleColor: '#CBBDB9',
    veryLightMayo: '#FAF3E8'
}
